import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useToken } from '../../../providers/Token.provider';
import { useLayout } from '../../../providers/Layout.provider';
import SocialButtons from '../../UI/SocialButtons/SocialButtons';
import PersonalProfileForm from './PersonalProfileForm';

const { Box, Title } = vp;

type FC = FunctionComponent;

const PersonalProfile: FC = () => {
  const defaultValues: vp.IQ11PersonalProfile = {
    FullName: '',
    EmailAddress: '',
    PhoneNumber: '',
    Address: '',
    Password: '',
    ConfirmPassword: '',
  };

  const handlers = {
    onCreatePersonalProfile: (_values: vp.IQ11PersonalProfile) => {},
  };

  const { setLayoutInfo } = useLayout();
  const { token } = useToken();
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'sun',
      '',
      60,
      15,
      0,
      true,
      false,
    );
  }, []);

  return (
    <>
      <Box mb="md" flx="col" height="auto">
        <Title title="Create Your Profile" size="lg" bold />
      </Box>

      <PersonalProfileForm defaultValues={defaultValues} handlers={handlers} />

      <SocialButtons title="Connect with" />
    </>
  );
};

export default PersonalProfile;
